import React from 'react';

const Spacer = ({ size }) => <div style={{ width: '100%', height: size }} />;

export default Spacer;
